module.exports = __webpack_public_path__ + "img/y_2021_hover.357ff2dd.png";